export function formatHeat(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return String(value);
}

export function formatHeatWan(value: number): string {
  return `${(value / 10000).toFixed(1)}万热度`;
}